







































import { defineComponent, ref } from '@vue/composition-api'

interface MultipleChoiceAnswer {
  label: string
  extra?: string
  correct: boolean
}

export default defineComponent({
  name: 'VMultipleChoice',

  props: {
    answers: {
      type: Array as () => MultipleChoiceAnswer[],
      default: () => []
    },
    horizontal: {
      type: Boolean,
      default: false
    }
  },

  setup() {
    const selectedItemIndex = ref<number | null>(null)

    return {
      selectedItemIndex
    }
  }
})
